import { Box, CheckBox, Text } from '@factorialco/deprecated-design-system'
import toQueryParams from 'jquery-param'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useHover } from 'modules/core/lib/hoverContext'

import { SOURCE } from 'modules/shift_management/hooks/reducers/schedule'
import { useEnabledFeatures } from 'modules/shift_management/hooks/useEnabledFeatures'
import { usePermissions } from 'modules/shift_management/hooks/usePermissions'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import {
  useSelectionDispatch,
  useSelectionState,
} from 'modules/shift_management/hooks/useSelection'
import type { ShiftsRow } from 'modules/shift_management/lib/types'

import ArchivedTooltip from './ArchivedTooltip'
import UrlButton from './UrlButton'

interface WorkAreaCellContentProps {
  shiftsRow: ShiftsRow
}

const WorkAreaCellContent = ({ shiftsRow }: WorkAreaCellContentProps) => {
  const [{ hasFeatureFlag }] = useEnabledFeatures()
  const [{ canManageLocation, canManageWorkArea }] = usePermissions()
  const { navigation } = useNavigation()
  const hover = useHover()

  const [{ view }] = useSchedule()
  const { rowsSelected, isEnabled } = useSelectionState()
  const dispatchSelection = useSelectionDispatch()

  const canManageWorkAreas =
    hasFeatureFlag('dev_location_work_areas') && canManageLocation && canManageWorkArea
  const newTableAbstraction = hasFeatureFlag('dev_shift_management_shifts_table_abstraction')

  const isWorkAreaArchived = shiftsRow.isRowArchivedWorkArea(view)
  const canManageShiftsRow = shiftsRow.canManage
  const rowSelectedSet = new Set(rowsSelected)
  const isChecked = rowSelectedSet.has(shiftsRow.key)
  const isCheckboxEnabled = canManageShiftsRow && !view.isDaily && (hover || isEnabled)

  const onSelect = () => {
    dispatchSelection({
      type: 'TOGGLE_SHIFTS_ROW',
      shiftsRow,
      view: view,
    })
  }

  const path =
    shiftsRow.urlParams &&
    navigation.settings.locations.locationsId.workAreas.add.fullPath(shiftsRow.urlParams)
  const queryParams = toQueryParams({ source: SOURCE, viewType: view.viewType })
  const route = path && `${path}?${queryParams}`

  return (
    <>
      <Box overflowX="hidden" gap="s8" width="full">
        <Box>
          <Box flexDirection="row" alignItems="center" gap="s8">
            <Text size="300" weight="medium" color="grey1000" ellipsis>
              {shiftsRow.title}
            </Text>
            {isWorkAreaArchived && <ArchivedTooltip />}
          </Box>
          <Text size="200" weight="normal" ellipsis>
            {shiftsRow.subtitle}
          </Text>
        </Box>
        {route && canManageShiftsRow && <UrlButton to={route} disabled={!canManageWorkAreas} />}
      </Box>
      {!newTableAbstraction && (
        <Box flexNoShrink>
          {isCheckboxEnabled && <CheckBox checked={isChecked} onClick={onSelect} />}
        </Box>
      )}
    </>
  )
}

export default observer(WorkAreaCellContent)
